<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.Overall_statistics") }}</h5>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <!-- <ComingSoon /> -->
      <div class="statics mt-4">
        <div class="row">
          <div
            class="col-lg-6 col-md-6 col-12"
            v-for="(value, key) in statics"
            :key="'i' + key"
          >
            <div class="box">
              <div class="icon">
                <i v-if="key === 'providers_count'" class="fas fa-user-tie"></i>
                <i v-if="key === 'drivers_count'" class="fas fa-truck"></i>
                <i
                  v-if="key === 'distribution_points_count'"
                  class="fas fa-map-marker-alt"
                ></i>
                <i
                  v-if="key === 'daily_packages_added'"
                  class="fas fa-box-open"
                ></i>
                <i
                  v-if="key === 'daily_packages_delivered'"
                  class="fas fa-check-circle"
                ></i>
                <i
                  v-if="key === 'daily_packages_returned'"
                  class="fas fa-undo"
                ></i>
              </div>

              <div class="info_box">
                <span v-if="key == 'providers_count'">{{
                  $t("PLACEHOLDERS.providers_count_static")
                }}</span>
                <span v-if="key == 'drivers_count'">{{
                  $t("PLACEHOLDERS.drivers_count_static")
                }}</span>
                <span v-if="key == 'distribution_points_count'">{{
                  $t("PLACEHOLDERS.distribution_points_count_static")
                }}</span>
                <span v-if="key == 'daily_packages_added'">{{
                  $t("PLACEHOLDERS.daily_packages_added_static")
                }}</span>
                <span v-if="key == 'daily_packages_delivered'">{{
                  $t("PLACEHOLDERS.daily_packages_delivered_static")
                }}</span>
                <span v-if="key == 'daily_packages_returned'">{{
                  $t("PLACEHOLDERS.daily_packages_returned_static")
                }}</span>

                <p class="number_box">{{ value }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->
  </div>
</template>

<script>
import ComingSoon from "@/components/ui/ComingSoon.vue";

export default {
  name: "HomePage",

  components: {
    ComingSoon,
  },

  data() {
    return {
      statics: [],
    };
  },

  methods: {
    async getStatics() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "home",
        });

        // console.log("All Data ==>", res.data.data);
        this.statics = res.data.data;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // End:: Set Table Rows
  },

  mounted() {
    this.getStatics();
  },
};
</script>

<style lang="scss" scoped>
.show_all_content_wrapper .statics .box .info_box {
  align-items: flex-start !important;
  width: 100% !important;
  padding-inline-start: 5% !important;
}
.show_all_content_wrapper {
  .statics {
    .box {
      background: #ef3405;
      padding: 25px;
      margin-bottom: 10px;
      border-radius: 5px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;

      //cursor: pointer;
      transition: all 0.5s;

      &:hover {
        background: #fff;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

        .icon {
          i {
            color: #ef3405;
          }
        }
        .info_box {
          span,
          p.number_box {
            color: #000;
          }
        }
      }

      .icon {
        height: 60px;
        min-width: 60px;
        width: 60px;
        border-radius: 60px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 25px;
          color: #000;
        }
      }

      .info_box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;

        span {
          font-size: 19px;
          color: #fff;
        }

        p.number_box {
          font-size: 30px;
          color: #fff;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
